import { File } from '../../api/content';

export function isFile(obj: any): obj is File {
  const file = obj as File;

  return !!file?.url && !!file.formats;
}
